// src/pages/Terms.js

import React from 'react';
import PageHeader from '../components/PageHeader';

const Terms = () => {
    return (
        <>
            <PageHeader
                title="Terms & Conditions"
                image="img/terms.jpg" // use your own path
                breadcrumbs={[
                    { label: "Terms & Conditions", active: true },
                ]}
            />
            <div className="container py-5">
                <p>Last Updated</p>
                <p>Welcome to Holiday Basket, your trusted partner in travel. By accessing or using our website or services, you agree to be bound by the following terms and conditions:</p>
                <div>
                    <h3>1.  General Information</h3>
                    <p>
                        Holiday Basket is a travel agency based in Dubai, UAE. We offer personalized tour packages, group
                        tour packages, cruise bookings, visa assistance, and are authorized resellers of Europamundo
                        Vacations packages
                    </p>

                    <h3>2. Booking and Payment</h3>
                    <ul>
                        <li>All bookings are subject to availability.</li>
                        <li>
                            A deposit or full payment may be required at the time of booking,
                            depending on the package or service.
                        </li>
                        <li>Payments can be made via credit card, bank transfer, or other approved methods.</li>
                        <li>
                            Prices are quoted in AED unless stated otherwise and are subject to change
                            without prior notice due to currency fluctuations, fuel surcharges, or other
                            external factors.
                        </li>
                    </ul>

                    <h3>3.  Cancellations and Refunds</h3>
                    <ul>
                        <li>Cancellation policies vary based on the package or service. Details will be provided at the
                            time of booking.</li>
                        <li>
                            Refunds, where applicable, will be processed within 14 working days, subject to cancellation
                            fees.
                        </li>
                    </ul>

                    <h3>4. Travel Documents</h3>
                    <ul>
                        <li>Clients are responsible for ensuring they have valid passports, visas, and other required
                            travel documents.</li>
                        <li>Holiday Basket offers visa assistance, but approval is subject to the discretion of the
                            respective consulate or embassy.</li>

                    </ul>

                    <h3>5. Third-Party Packages</h3>
                    <ul>
                        <li>Packages from Europamundo Vacations or other third-party providers are governed by their
                            respective terms and conditions.</li>
                        <li>Holiday Basket acts as a facilitator and is not liable for any changes, cancellations, or issues
                            arising from third-party services.</li>

                    </ul>

                    <h3>6. Liability Disclaimer</h3>
                    <ul>
                        <li>Holiday Basket is not liable for delays, losses, injuries, or damages caused by acts of God,
                            natural disasters, strikes, or actions of third parties.</li>
                        <li>We are not responsible for any expenses incurred due to missed connections, re-routing, or
                            force majeure events.</li>

                    </ul>

                    <h3>7. Changes to Itinerary</h3>
                    <ul>
                        <li>Holiday Basket reserves the right to make changes to the itinerary or travel arrangements
                            due to unforeseen circumstances.</li>
                        <li>We will make every effort to inform clients and offer suitable alternatives.</li>

                    </ul>

                    <h3>8. Governing Law</h3>
                    <p>These terms and conditions are governed by the laws of the United Arab Emirates. Any disputes shall
                        be subject to the exclusive jurisdiction of Dubai courts.</p>
                </div>
            </div>
        </>

    );
};

export default Terms;
